import {
    sagaEffects,
    api,
    runSagas,
    config,
    menuActions,
    selectors as menuSelectors,
    localforage,
    get,
    moment,
} from '../dependencies';

import * as actions from './actions';
import actionTypes from './actionTypes';
import * as constants from './constants';
import { selectedSelector, favouriteSelector } from './selectors';

function* handleRequestRestaurants() {
    try {
        const selectedRestaurants = yield sagaEffects.select(selectedSelector);
        const response = yield api.get(config.api.restaurants);

        yield sagaEffects.put(actions.setRestaurants(response.data));

        const restaurantsIds = response.data.filter(({ id }) => selectedRestaurants[id]).map(({ id }) => id);

        yield sagaEffects.put(menuActions.requestMenus(restaurantsIds, moment()));
    } catch (e) {
        // TODO: handle errors
    }
}

function* handleCheckSelectedRestaurants() {
    // if any new restaurant that is selected hasn't menu yet request the menu
    const selectedRestaurants = yield sagaEffects.select(selectedSelector);
    const menusByRestaurantId = yield sagaEffects.select(menuSelectors.menusKeyedByRestaurantIdSelector);

    const restaurantWithoutMenuIds = Object.keys(selectedRestaurants)
        .filter(restaurantId => selectedRestaurants[restaurantId] && !menusByRestaurantId[restaurantId])
        .map(restaurantId => Number(restaurantId));

    yield sagaEffects.put(menuActions.requestMenus(restaurantWithoutMenuIds, moment()));
}

function* handleLoadRestaurantsSettings() {
    try {
        const restoredData = yield localforage.getItem(config.appStorageKey);
        const restaurants = get(restoredData, constants.STORAGE_KEY);
        if (restaurants) {
            if (restaurants.selected) {
                yield sagaEffects.put(actions.setSelected(restaurants.selected));
            }
            if (restaurants.favourite) {
                yield sagaEffects.put(actions.setFavourite(restaurants.favourite));
            }
        }
    } catch (e) {
        throw e;
    }
}

function* handleSaveRestaurantsSettings() {
    try {
        const currentData = yield localforage.getItem(config.appStorageKey);
        const selectedRestaurants = yield sagaEffects.select(selectedSelector);
        const favouriteRestaurants = yield sagaEffects.select(favouriteSelector);

        yield localforage.setItem(config.appStorageKey, {
            ...currentData,
            [constants.STORAGE_KEY]: {
                selected: selectedRestaurants,
                favourite: favouriteRestaurants,
            },
        });
    } catch (e) {
        throw e;
    }
}

const handlers = {
    [actionTypes.RESTAURANTS_SETTINGS_LOAD]: handleLoadRestaurantsSettings,
    [actionTypes.RESTAURANTS_SETTINGS_SAVE]: handleSaveRestaurantsSettings,
    [actionTypes.TOGGLE_RESTAURANT_FAVOURITE]: handleSaveRestaurantsSettings,
    [actionTypes.REQUEST_RESTAURANTS]: handleRequestRestaurants,
    [actionTypes.CHECK_SELECTED_RESTAURANTS]: handleCheckSelectedRestaurants,
};

// we want to call it just once
function* initRestaurants() {
    yield sagaEffects.put(actions.loadRestaurantsSettings());
}

export default function*() {
    yield sagaEffects.all([
        runSagas(handlers),
        sagaEffects.takeLatest(actionTypes.RESTAURANTS_SETTINGS_LOAD_COMPLETED, handleCheckSelectedRestaurants),
        initRestaurants(),
    ]);
}
